import React from 'react';

export default function SectionHeading({ eyebrow, title, desc, center = true }) {
  return (
    <div className={`${center ? 'mx-auto text-center' : ''} max-w-3xl reveal`}>
      {eyebrow && <div className="eyebrow mb-4">{eyebrow}</div>}
      <h2 className="text-3xl md:text-5xl font-extrabold tracking-tight" style={{ color: 'var(--ink)' }}>
        {title}
      </h2>
      {desc && (
        <p className="mt-5 text-[17px] leading-relaxed" style={{ color: 'var(--body)' }}>{desc}</p>
      )}
    </div>
  );
}